import type { RouteLocationNormalized } from 'vue-router'

export type Language = (typeof languageSupported)[number]
export type Languages = { [key in Language]: string }

/**
 * Languages
 */
const languageDefault: Language = 'en'
const languageSupported = ['en', 'fr'] as const
const languageRedirect: 'none' | 'default' | 'preferred' = 'default'

export function getLanguageDefault() {
  return languageDefault
}

export function getlanguageSupported() {
  return languageSupported
}

export function getLanguageRedirect() {
  return languageRedirect
}

export function getLanguageFromRoute(route: RouteLocationNormalized) {
  let language = getLanguageDefault()

  if (route.params.lang) {
    language = route.params.lang as Language
  }

  return language
}
